import React, { createContext, useContext, useState, useCallback, Suspense } from "react";
import { lazyWithRetry } from "../lib/lazyWithRetry";

const FloatingPlayer = lazyWithRetry(() => import("../components/cinema/FloatingPlayer").then((m) => ({ default: m.FloatingPlayer })));

const CinemaPlayerContext = createContext(null);

export function useCinemaPlayer() {
  return useContext(CinemaPlayerContext);
}

export function CinemaPlayerProvider({ children }) {
  const [video, setVideo] = useState(null);

  const play = useCallback((v) => setVideo(v), []);
  const close = useCallback(() => setVideo(null), []);

  return (
    <CinemaPlayerContext.Provider value={{ video, play, close }}>
      {children}
      {video && <Suspense fallback={null}><FloatingPlayer video={video} onClose={close} /></Suspense>}
    </CinemaPlayerContext.Provider>
  );
}
